import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSeoHead } from "./head";
import { resolveSeo } from "./config";
import { resolveSchemas } from "./schema";
import JsonLd from "./JsonLd";

/**
 * 集中式路由感知 SEO 管理器：
 * 根据当前路由与语言统一更新文档 head 元数据，并注入对应的 Schema.org JSON-LD。
 * 该组件不渲染任何可见 UI。
 */
export default function SeoManager() {
  const { pathname } = useLocation();
  const { i18n } = useTranslation();

  const meta = resolveSeo(pathname, i18n.language);
  useSeoHead(meta, i18n.language);

  const schemas = resolveSchemas(pathname, i18n.language);

  return (
    <>
      {schemas.map((schema, index) => (
        <JsonLd key={index} data={schema} />
      ))}
    </>
  );
}